import { ReactComponent as InformationModal } from "../../assets/icons/InformationModal.svg";
import Dialog from "../../components/Dialog";
import UploadFileStyles from "../../styles/pages/UploadFilesStyles";

const { StyledImportButton, StyledModalText } = UploadFileStyles;

interface IProps {
    open: boolean;
    onClose: () => void;
}

const DialogErrorStudentAssociado: React.FC<IProps> = ({ open, onClose }) => {
    const closeDialog = () => onClose();
    return (
        <Dialog
            openModal={open}
            onHide={closeDialog}
            modalIcon={<InformationModal />}
        >
            <StyledModalText>
                Estudante já está associado a esta atividade.
            </StyledModalText>

            <StyledImportButton
                style={{ width: 86, marginTop: 24 }}
                onClick={closeDialog}
            >
                OK
            </StyledImportButton>
        </Dialog>
    );
};

export default DialogErrorStudentAssociado;
